<template>
  <div class="registration-image">
    <produto-imagem v-if="croppable" :value="value ? [value] : []" :readonly="disabled" :company-id="companyId" :url-rest="urlRest" :image-label="imageLabel" :pasta="pasta" @input="$emit('input', $event[0] || null)" @loading="$emit('loading', $event)" />
    <template v-else>
    <label><i class="far fa-image color-theme me-2"></i>Foto</label>
    <div class="d-flex flex-wrap align-items-center gap-3">
      <img v-if="value" :src="imageUrl" alt="Foto do cadastro" class="registration-image-preview" @error="$store.dispatch('imageError', $event)">
      <div class="flex-grow-1">
        <input v-if="!disabled" ref="file" type="file" accept="image/*" class="form-control" :disabled="uploading" aria-label="Anexar foto" @change="upload">
        <small v-if="uploading" class="text-secondary" role="status">Enviando imagem…</small>
        <small v-else-if="!value" class="text-secondary">{{ disabled ? 'Nenhuma foto anexada.' : 'Selecione uma imagem para anexar ao cadastro.' }}</small>
        <button v-if="value && !disabled" type="button" class="btn btn-sm btn-outline-danger mt-2" :disabled="uploading" @click="$emit('input', null)"><i class="far fa-trash me-1"></i>Remover foto</button>
        <div v-if="error" class="field-validation-feedback" role="alert">{{ error }}</div>
      </div>
    </div>
    </template>
  </div>
</template>
<script>
import { resolverUrlArquivo } from '@/utils/produtoImagem'
import { uploadRegistrationImage } from '@/services/imageUpload'
import ProdutoImagem from '@/components/produtos/ProdutoImagem.vue'
export default {
  name: 'RegistrationImage',
  components: { ProdutoImagem },
  props: { value: [String, Number], disabled: Boolean, companyId: [Number, String], urlRest: String, croppable: Boolean, imageLabel: { type: String, default: 'cadastro' }, pasta: { type: String, default: 'produtos' } },
  data: () => ({ uploading: false, error: '' }),
  computed: { imageUrl() { return resolverUrlArquivo(this.value, this.urlRest) } },
  methods: {
    async upload(event) {
      const file = event.target.files[0]
      if (!file || this.disabled || this.uploading) return
      this.error = ''; this.uploading = true; this.$emit('loading', true)
      const companyId = this.companyId
      try {
        const reference = await uploadRegistrationImage(this.$axios, this.urlRest, companyId, file, this.pasta)
        if (!this._isDestroyed && !this.disabled && this.companyId === companyId) this.$emit('input', reference)
      } catch (error) {
        if (!this._isDestroyed) this.error = error.response ? 'Não foi possível enviar a imagem. Tente novamente.' : error.message
      } finally {
        if (!this._isDestroyed) { this.uploading = false; this.$emit('loading', false); event.target.value = '' }
      }
    }
  }
}
</script>
<style scoped>
.registration-image-preview { width: 100px; height: 100px; object-fit: contain; border: 1px solid #dce2e9; border-radius: 7px; background: #fff; }
</style>
